import React,{ useEffect, useState } from 'react'
import getUser,{loginUrl} from '../data-source/user'

const LoginContext = React.createContext([])

export const LoginProvider = ({children,onChange=() => {},errorHandler = () => {}}) => {
    const [user,setUser] = useState({})
    
    useEffect( () => {
        getUser()
        .then( setUser )
        .catch( e => {
            setUser({loginUrl: loginUrl})
            errorHandler(e)
        })
    },[errorHandler])

    useEffect( () => {
        onChange(user)
    }, [user,onChange])

    return <LoginContext.Provider value={user}>{children}</LoginContext.Provider>
}
export const LoginConsumer = LoginContext.Consumer
export default LoginContext